import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const SegmentsApi = {
  destroy(id, segmentType) {
    return http.delete(`${orgPath()}/segments/${segmentType}/${id}`).then((response) => response.data.data);
  },
};
